import '@babel/polyfill'
import Vue from 'vue'
import 'mutationobserver-shim'
import './utils/filter'
// import './config/firebase'
import App from './App.vue'
import router from './router'
import store from './store'

// import Raphael from 'raphael/raphael'
import './plugins'
import './registerServiceWorker'
import AlgoliaComponents from 'vue-instantsearch'
import i18n from './i18n'
import './directives'
// global.Raphael = Raphael

import './global-components'

Vue.use(AlgoliaComponents)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
